"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureTransactionList = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../labeling"));
var _SectionHeader = _interopRequireDefault(require("../../components/SectionHeader"));
var _Transactions = _interopRequireDefault(require("../../components/Transactions"));
var _propTypes = require("prop-types");
var _TransactionListStyled = require("./TransactionListStyled");
var TransactionList = function TransactionList(_ref) {
  var t = _ref.t;
  return /*#__PURE__*/_react.default.createElement(_TransactionListStyled.WrapStyled, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
    marginTop: "25px"
  }, t('Transactions')), /*#__PURE__*/_react.default.createElement(_Transactions.default, null));
};
exports.PureTransactionList = TransactionList;
TransactionList.propTypes = {
  t: _propTypes.PropTypes.func
};
TransactionList.defaultProps = {
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(TransactionList));
exports.default = _default;